import React, { Component } from 'react';
import { Popover, NavBar, Icon } from 'antd-mobile';
import { Icon as AIcon } from 'antd';
import history from 'common/history'
 //引入样式
import './index.css';
const Item = Popover.Item;
class Header extends Component {
  constructor(props){
    super(props);
    this.state = {
      visible: false,
      selected: '',
    }
  }
  onSelect = (opt) => {
    // console.log(opt.props.value);
    this.setState({
      visible: false,
      selected: opt.props.value,
    });
    if(opt.props.value==='home'){
       history.push('/')
    }else if(opt.props.value==='personal'){
      history.push('/personal')
    }else if(opt.props.value==='cancel'){
      this.handleVisibleChange(false)
    }else if (opt.props.value==='sginOut') {
        const getCookie = (name) => {
          let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
          if (arr = document.cookie.match(reg)) return unescape(arr[2])
          else return null
        }
        const delCookie = (name, domain, path = "/") => {
          let exp = new Date()
          exp.setTime(exp.getTime() - 1)
          let cval=getCookie(name)
          if(cval!=null&&!domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}`
          else if (cval!=null&&domain) document.cookie = `${name}=${cval}; expires=${exp.toGMTString()}; path=${path}; domain=${domain}`
        }
        console.log(window.AppConfig.domain)
        delCookie('_token', window.AppConfig.domain)
        const tenantCode = localStorage.getItem("tenant_code")
        localStorage.removeItem('tenant_code')
        window.location.href = `${window.AppConfig.loginUrl}?tenant_code=${tenantCode}`
    }
  };
  handleVisibleChange = (visible) => {
    this.setState({
      visible,
    });
  };

  clickHandle() {
    window.history.back()
  }
  isWeixin = () => {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") return true
    else return false
  }
  render(){
    return(
     <NavBar
        className="fixd-header mobile_header"
        style={{ background :"#202129" }}
        icon={<Icon type="left" />}
        onLeftClick={this.clickHandle.bind(this)}
        rightContent={
          <Popover mask
            overlayClassName="fortest"
            overlayStyle={{ color: 'currentColor' }}
            visible={this.state.visible}
            overlay={this.isWeixin() ? 
              [
              (<Item key="1" value="home"
                icon={<AIcon type="home" theme="filled" />} >
                 返回首页
                </Item>),
              (<Item key="2"
              icon={<AIcon type="user"/>}
              style={{ whiteSpace: 'nowrap' }}>
                {JSON.parse(localStorage.getItem("userinfo")||"{}").user_name}
              </Item>)
            ] :
              [
              (<Item key="1" value="home"
                icon={<AIcon type="home" theme="filled" />} >
                 返回首页
                </Item>),
              (<Item key="2"
              icon={<AIcon type="user"/>}
              style={{ whiteSpace: 'nowrap' }}>
                {JSON.parse(localStorage.getItem("userinfo")||"{}").user_name}
              </Item>)
              // (<Item key="3" value="sginOut"
              // icon={<AIcon type="close-circle"/>}
              // style={{ whiteSpace: 'nowrap' }}>
              //   退出
              // </Item>)
            ]}
            align={{
              overflow: { adjustY: 0, adjustX: 0 },
              offset: [-10, 0],
            }}
            onVisibleChange={this.handleVisibleChange}
            onSelect={this.onSelect}
          >
            <div style={{
              height: '100%',
              padding: '0 15px',
              marginRight: '-15px',
              display: 'flex',
              alignItems: 'center',
            }}
            >
              <Icon type="ellipsis" />
            </div>
          </Popover>
        }
      >
        <span className="titleName">{this.props.title}</span>
      </NavBar>
      )
  }
}

export default Header;
